module.exports = __webpack_public_path__ + "img/sending2.97d2057b.gif";